__webpack_require__.p = "/QWERTY-WDAI/";